import type { ReactNode, SVGProps } from 'react'

export type IconName =
  | 'overview'
  | 'discovery'
  | 'strategy'
  | 'roadmap'
  | 'register'
  | 'suppliers'
  | 'work'
  | 'reports'
  | 'administration'
  | 'user'
  | 'send'
  | 'resend'
  | 'cancel'
  | 'edit'
  | 'shield'
  | 'signout'
  | 'arrow-right'
  | 'pen'
  | 'search'
  | 'document'
  | 'chart'
  | 'workflow'
  | 'media'
  | 'help'
  | 'user-check'
  | 'users'
  | 'lock'
  | 'scale'
  | 'alert'
  | 'clock'
  | 'dollar'
  | 'check'
  | 'heart'
  | 'trend'
  | 'accessibility'
  | 'lightbulb'
  | 'plus'
  | 'info'

type IconProps = SVGProps<SVGSVGElement> & {
  name: IconName
  size?: number
}

function paths(name: IconName): ReactNode {
  switch (name) {
    case 'overview':
      return <><path d="m3 11 9-8 9 8"/><path d="M5 10v10h14V10"/><path d="M9 20v-6h6v6"/></>
    case 'discovery':
      return <><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/><path d="M11 8v6M8 11h6"/></>
    case 'strategy':
      return <><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><path d="M12 3v3M21 12h-3M12 21v-3M3 12h3"/></>
    case 'roadmap':
      return <><circle cx="6" cy="18" r="2"/><circle cx="18" cy="6" r="2"/><path d="M8 18h2c4 0 4-6 8-6h1"/><path d="M6 16V7h8"/><path d="m12 5 2 2-2 2"/></>
    case 'register':
      return <><path d="M5 4h14v16H5z"/><path d="M8 8h8M8 12h8M8 16h5"/></>
    case 'suppliers':
      return <><path d="M3 21h18"/><path d="M5 21V8l7-4 7 4v13"/><path d="M9 21v-5h6v5"/><path d="M8 10h.01M12 10h.01M16 10h.01"/></>
    case 'work':
      return <><rect x="3" y="6" width="18" height="14" rx="1"/><path d="M8 6V4h8v2M3 11h18"/><path d="M10 11v2h4v-2"/></>
    case 'reports':
      return <><path d="M5 3h10l4 4v14H5z"/><path d="M15 3v5h4"/><path d="M8 17v-4M12 17V9M16 17v-6"/></>
    case 'administration':
      return <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.86 2.86-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1V21H9.6v-.08a1.7 1.7 0 0 0-1.4-1.66 1.7 1.7 0 0 0-1.54.48l-.06.06-2.86-2.86.06-.06A1.7 1.7 0 0 0 4.6 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1-.4H3V9.6h.08a1.7 1.7 0 0 0 1.66-1.4 1.7 1.7 0 0 0-.48-1.54L4.2 6.6 7.06 3.74l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1V3h4v.08a1.7 1.7 0 0 0 1.4 1.66 1.7 1.7 0 0 0 1.54-.48l.06-.06 2.86 2.86-.06.06A1.7 1.7 0 0 0 19.4 9c.15.36.36.7.6 1 .27.3.62.5 1 .6h.08v4h-.08a1.7 1.7 0 0 0-1.6.4Z"/></>
    case 'user':
      return <><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></>
    case 'send':
      return <><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></>
    case 'resend':
      return <><path d="M20 6v5h-5"/><path d="M19 11a7 7 0 1 0-1 6"/></>
    case 'cancel':
      return <><circle cx="12" cy="12" r="9"/><path d="m9 9 6 6M15 9l-6 6"/></>
    case 'edit':
      return <><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z"/></>
    case 'shield':
      return <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/><path d="m9 12 2 2 4-4"/></>
    case 'signout':
      return <><path d="M10 17l5-5-5-5M15 12H3"/><path d="M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5"/></>
    case 'arrow-right':
      return <><path d="M5 12h14M13 6l6 6-6 6"/></>
    case 'pen':
      return <><path d="M12 20h9"/><path d="M4 16.5V20h3.5L19 8.5 15.5 5 4 16.5Z"/><path d="m13.5 7 3.5 3.5"/></>
    case 'search':
      return <><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></>
    case 'document':
      return <><path d="M6 3h9l4 4v14H6z"/><path d="M15 3v5h4M9 12h7M9 16h7"/></>
    case 'chart':
      return <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/><path d="m4 7 5-3 6 5 5-4"/></>
    case 'workflow':
      return <><circle cx="6" cy="6" r="2"/><circle cx="18" cy="6" r="2"/><circle cx="18" cy="18" r="2"/><path d="M8 6h8M18 8v8M16 18H9a3 3 0 0 1-3-3V8"/></>
    case 'media':
      return <><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m4 17 5-4 4 3 3-2 4 3"/></>
    case 'help':
      return <><circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.4 2.4 0 1 1 3.9 1.9c-.9.7-1.7 1.1-1.7 2.6M12 17h.01"/></>
    case 'user-check':
      return <><circle cx="9" cy="8" r="4"/><path d="M2.5 21a6.5 6.5 0 0 1 11.5-4.2"/><path d="m16 18 2 2 4-5"/></>
    case 'users':
      return <><circle cx="9" cy="8" r="3"/><path d="M3 20a6 6 0 0 1 12 0"/><path d="M16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 6"/></>
    case 'lock':
      return <><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3"/></>
    case 'scale':
      return <><path d="M12 3v18M5 6h14M7 6l-4 7h8L7 6ZM17 6l-4 7h8l-4-7ZM8 21h8"/></>
    case 'alert':
      return <><path d="M12 3 2.5 20h19L12 3Z"/><path d="M12 9v5M12 17h.01"/></>
    case 'clock':
      return <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>
    case 'dollar':
      return <><circle cx="12" cy="12" r="9"/><path d="M15.5 8.5c-.7-.8-1.8-1.2-3-1.2-1.7 0-3 .8-3 2.1 0 3.2 6 1.6 6 5 0 1.4-1.4 2.3-3.3 2.3-1.5 0-2.8-.5-3.7-1.5M12 5.5v13"/></>
    case 'check':
      return <><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16.5 9"/></>
    case 'heart':
      return <path d="M20.8 5.8a5.3 5.3 0 0 0-7.5 0L12 7.1l-1.3-1.3a5.3 5.3 0 0 0-7.5 7.5L12 22l8.8-8.7a5.3 5.3 0 0 0 0-7.5Z"/>
    case 'trend':
      return <><path d="M3 17 9 11l4 4 8-9"/><path d="M15 6h6v6"/></>
    case 'accessibility':
      return <><circle cx="12" cy="4" r="2"/><path d="M5 8h14M12 6v15M8 21l4-7 4 7M8 10l4 4 4-4"/></>
    case 'lightbulb':
      return <><path d="M9 18h6M10 22h4"/><path d="M8 15c-1.3-1-2-2.7-2-4.4A6 6 0 1 1 18 10.6c0 1.7-.7 3.4-2 4.4-.7.6-1 1.1-1 2H9c0-.9-.3-1.4-1-2Z"/></>
    case 'plus':
      return <><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></>
    case 'info':
      return <><circle cx="12" cy="12" r="9"/><path d="M12 11v6M12 7h.01"/></>
  }
}

export function Icon({ name, size = 18, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      className={`icon icon-${name}`}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      {...props}
    >
      {paths(name)}
    </svg>
  )
}
